/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Step_Tea_PurchaseInputs */

const vi_order_lot_trace_step_tea_purchase = /** @type {(inputs: Order_Lot_Trace_Step_Tea_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn mua chè`)
};

/**

* @param {Order_Lot_Trace_Step_Tea_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_step_tea_purchase = /** @type {((inputs?: Order_Lot_Trace_Step_Tea_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Step_Tea_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_step_tea_purchase(inputs)
});